module.exports = "/_next/static/images/LeveragePreBuiltCloudSources@2x-4618b1ab49ab1831b0a66bd7765682c3.webp";